import {
  ChannelBreakdownCard,
  ChannelEntry,
} from '../../components/cards/ChannelBreakdownCard'
import { useAppSelector } from '../../hooks'
import { useGetCreatorChannelBreakdownQuery } from '../../redux-toolkits/vendors/vendors.slice'
import { DateFilterQueryProps } from '../../redux-toolkits/shared/shared.type'
export const SingleVendorChannelBreakdown = ({
  id,
  dateFilterProps,
}: {
  id: string
  dateFilterProps: DateFilterQueryProps
}) => {
  const { selectedFulfilmentCenters } = useAppSelector((state) => state.auth)

  const { data } = useGetCreatorChannelBreakdownQuery(
    {
      id,
      ...dateFilterProps,
      fulfilmentCentreId:
        selectedFulfilmentCenters.map((c) => c._id).join(',') || undefined,
    },
    { refetchOnMountOrArgChange: true },
  )

  const channels = data?.data?.storefrontMetrics ?? []

  if (channels.length === 0) return null

  const entries: ChannelEntry[] = channels.map((channel) => ({
    label: channel.name,
    amount: channel.amount,
    orderCount: channel.orderCount,
    subItems: channel.metrics.map((m) => ({
      label: `${m.fulfilmentCentreName ?? '—'} — ${
        m.deliveryType.charAt(0).toUpperCase() +
        m.deliveryType.slice(1).toLowerCase()
      }`,
      amount: m.amount,
      orderCount: m.orderCount,
    })),
  }))

  return <ChannelBreakdownCard title="Channel Breakdown" entries={entries} />
}
